export default __webpack_public_path__ + "static/media/contact.df318153.jpg";